module.exports = __webpack_public_path__ + "static/media/dark-bathroom.880f16d8.jpg";